(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuntius-renovacion"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(root){
if(root.dataset.nhReady)return;root.dataset.nhReady='true';
let busy=false;const variant=root.dataset.variant;const base=root.dataset.cartRoot.replace(/\/?$/,'/');
const selects=[...root.querySelectorAll('.pack-select')];const buttons=[...root.querySelectorAll('button[type="submit"]')];const originalDisabled=buttons.map(b=>b.disabled);
const prices={1:79,2:141,3:194};
const status=document.createElement('p');status.className='nh-order-status';status.setAttribute('role','status');root.querySelector('.sticky').append(status);
function sync(n){n=Number(n);if(![1,2,3].includes(n))n=1;selects.forEach(s=>s.value=String(n));root.querySelectorAll('.product-price,.amount').forEach(e=>e.textContent='S/ '+prices[n].toFixed(2));return n}
function unlock(){busy=false;buttons.forEach((b,i)=>b.disabled=originalDisabled[i]);selects.forEach(s=>s.disabled=false);root.removeAttribute('aria-busy')}
async function request(path,body){const response=await fetch(base+path,{credentials:'same-origin',cache:'no-store',method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined});const data=await response.json();if(!response.ok||data.status>=400)throw new Error(data.description||'No pudimos actualizar el pedido. Inténtalo nuevamente.');return data}
selects.forEach(s=>s.addEventListener('change',()=>sync(s.value)));
root.querySelectorAll('form').forEach(form=>form.addEventListener('submit',async event=>{
event.preventDefault();if(busy)return;const quantity=sync(form.querySelector('.pack-select').value);busy=true;status.textContent='Preparando tu pedido…';root.setAttribute('aria-busy','true');buttons.forEach(b=>b.disabled=true);selects.forEach(s=>s.disabled=true);
try{const cart=await request('cart.js');const matches=cart.items.filter(i=>String(i.variant_id)===variant);const updates={};if(matches.length){matches.forEach((item,index)=>updates[item.key]=index===0?quantity:0)}else{updates[variant]=quantity}
await request('cart/update.js',{updates});const checked=await request('cart.js');const finalQuantity=checked.items.filter(i=>String(i.variant_id)===variant).reduce((sum,i)=>sum+i.quantity,0);if(finalQuantity!==quantity)throw new Error('Revisa la cantidad antes de continuar. Inténtalo nuevamente.');
window.location.assign(base+'checkout');
}catch(error){status.textContent=error.message||'No pudimos actualizar el pedido. Inténtalo nuevamente.';unlock()}
}));
window.addEventListener('pageshow',()=>{unlock();status.textContent='';sync(selects[0].value)});
sync(selects[0].value)
}
document.querySelectorAll('.nh-renov').forEach(init);
document.addEventListener('shopify:section:load',()=>document.querySelectorAll('.nh-renov').forEach(init))
})();

  } catch(e) { console.error(e); }
})();
})();
